export default `float s=3., e;
    for(int j=0;++j<5;)
      s*=e=1./min(dot(p,p),1.),
      p=abs(p)*e-1.5;
    return length(p.yz)/s;
  }`